module.exports = __webpack_public_path__ + "static/ANGACOM_events-desktop-hero-c3ee3fd9b85d380db2517eefd621e48f.jpg";